import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';

const Footer = () => {

    const [inmuebles, setInmuebles] = useState([]);
    const [modal5, setModal5] = useState(false);
    const [actualizar_inmueble, setActualizar_inmueble] = useState(0);
    const [look_inmueble, setLook_inmueble] = useState(false);
    const [select_footer, setselect_footer] = useState([]);

    const [inmueble, setInmueble] = useState({
        tipo_propiedad: '',
        nombre: '',
        tipo:0
    });

    useEffect(() => {
        fetch('/p_footer', { headers: { 'Content-Type': 'application/json' } })
        .then(res => res.json())
        .then(res => { setInmuebles(res) })
        .catch(err => { console.log('Error: ' + err) })

        fetch('/p_footer_select', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => setselect_footer(res))
        .catch(err => console.log('Error: '+err))
    }, [modal5]);

    useEffect(() => {
        if (!actualizar_inmueble || !modal5) {
            setActualizar_inmueble(0)
            setInmueble({
                tipo_propiedad: '',
                nombre: '',
                tipo:0
            })
        }
    }, [modal5]);

    const recuperarState = () => {

        fetch('/p_footer', { headers: { 'Content-Type': 'application/json' } })
        .then(res => res.json())
        .then(res => { setInmuebles(res) })
        .catch(err => { console.log('Error: ' + err) })

        fetch('/p_footer_select', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => setselect_footer(res))
        .catch(err => console.log('Error: '+err))
    }

    const toggle5 = () => {
        setModal5(!modal5)
    }

    const cambio_inmueble = e => { 
        if(e.target.name=='tipo_propiedad'){
            const index = select_footer.findIndex(select_foote => select_foote.NOMBRE === e.target.value);
            setInmueble({
                ...inmueble,
                [e.target.name]: e.target.value,
                tipo: select_footer[index].TIPO
            })
        }
        else{
            setInmueble({
                ...inmueble,
                [e.target.name]: e.target.value
            })
        }
    }

    const editar_inmueble = (id) => {
        setActualizar_inmueble(id)
        var datos_temp = inmuebles.find(x => x.ID == id)
        setInmueble({
            ID: id,
            nombre: datos_temp.NOMBRE,
            tipo_propiedad:datos_temp.SELECCION,
            tipo:datos_temp.TIPO
        })
        setModal5(true)
    }

    const agregarInmueble = () => {
        setLook_inmueble(true)

        fetch('/p_footer', {
            method: 'POST',
            body: JSON.stringify({ ...inmueble }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                toast.success(`Agregado`);
                setModal5(!modal5)
                setLook_inmueble(false)
            })
            .catch(err => { console.log('Error: ' + err); setLook_inmueble(false) })
    }

    const actualizarInmueble = () => {
        setLook_inmueble(true)

        fetch('/p_footer', {
            method: 'PUT',
            body: JSON.stringify({ ...inmueble }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                toast.success(`Agregado`);
                setModal5(!modal5)
                setLook_inmueble(false)
                setInmuebles([])
            })
            .catch(err => { console.log('Error: ' + err); setLook_inmueble(false) })
    }

    const borrar_inmueble = (id) => {
        fetch('/p_footer', {
            method: 'DELETE',
            body: JSON.stringify({ ID: id }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                toast.success(`Borrado`);
                recuperarState()
            })
            .catch(err => { console.log('Error: ' + err); setLook_inmueble(false) })
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-12 mt-4">
                    <div className="card">
                        <div className="card-header bg-primary d-flex justify-content-between">
                            <h5 className="text-light text-center">Departamentos y  Subdepartamentos</h5>
                            { inmuebles.length < 19 && <i className="icofont icofont-ui-add text-left" style={{ color: 'white', marginTop: '5px', cursor: 'pointer' }} onClick={toggle5}></i> }
                        </div>
                        <div className="card-body">
                            {
                                inmuebles.map(x =>
                                    <div key={x.NOMBRE} className="d-flex justify-content-between mt-2">
                                        <div className="text-dark">{x.NOMBRE}</div>
                                        <div>
                                            <i className="icofont icofont-pencil-alt-5 mr-3" style={{ color: 'blue', cursor: 'pointer' }} onClick={() => editar_inmueble(x.ID)}></i>
                                            <i className="icofont icofont-trash" style={{ color: 'red', cursor: 'pointer' }} onClick={() => borrar_inmueble(x.ID)}></i>
                                        </div>
                                    </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={modal5} toggle={toggle5}>
                <ModalHeader toggle={toggle5}>{actualizar_inmueble == 0 ? 'Añadir' : 'Actualizar'}</ModalHeader>
                <ModalBody>
                    <form>
                        <div className="form-group">
                            <label className="col-form-label" htmlFor="recipient-name">Nombre:</label>
                            <input name="nombre" value={inmueble.nombre} onChange={cambio_inmueble} className="form-control" type="text" placeholder="Nombre" />
                        </div>
                        <div className="form-group">
                            <label>Tipo de propiedad</label>
                            <select name="tipo_propiedad" value={inmueble.tipo_propiedad} onChange={cambio_inmueble} className="listing-input hero__form-input  form-control custom-select py-0" >
                                <option value="">Selecciona el tipo de propiedad</option>
                                {select_footer.map((x) => <option key={x.NOMBRE} value={x.NOMBRE}>{x.NOMBRE}</option>)}
                            </select>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => actualizar_inmueble == 0 ? agregarInmueble() : actualizarInmueble()} disabled={look_inmueble}>{actualizar_inmueble == 0 ? 'Guardar' : 'Actualizar'}</Button>
                    <Button color="secondary" onClick={toggle5} disabled={look_inmueble} >Cancelar</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default Footer;